import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout.js';
import { EmptyState } from './components/EmptyState.js';
import { Connect } from './pages/Connect.js';
import { Connections } from './pages/Connections.js';
import { Dashboard } from './pages/Dashboard.js';
import { Models } from './pages/Models.js';
import { Onboarding } from './pages/Onboarding.js';
import { Settings } from './pages/Settings.js';

const client = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: (failureCount, error) => {
        const status = (error as { status?: number }).status ?? 0;
        if (status >= 400 && status < 500) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={client}>
      <BrowserRouter basename={import.meta.env.BASE_URL}>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="connections" element={<Connections />} />
            <Route path="models" element={<Models />} />
            <Route path="connect" element={<Connect />} />
            <Route path="onboarding" element={<Onboarding />} />
            <Route path="settings" element={<Settings />} />
            <Route
              path="*"
              element={<EmptyState title="Not found" description="That page does not exist." />}
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
